<template>
    <div class="body">
		<div style="padding-top:17vh;display:flex;justify-content: center;align-items: center;flex-wrap: wrap;">
			<span style="width:100vh;margin:0;text-align: center;font-weight: 800; font-size: 60px;color: #fff;font-family:'Gentium Basic', serif;">2025</span>
			<span style="width:100vh;margin:0;text-align: center;font-weight: 800;font-size: 27px;color: #4884dc;text-shadow: #fff 0px 0px 5px,   #fff 0px 0px 4px,   #fff 0px 0px 4px, #fff 0px 0px 5px,   #fff 0px 0px 5px,   #fff 0px 0px 5px;font-family: 'Eczar', cursive,sans-serif;">富学宝典</span>
			<span style="margin:7px;background:cadetblue;padding: 4px 17px;border-radius: 11px;background: #4884dc;font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman',cursive, serif; color:#fff;">二月学习报告</span>
			<span style="width:100vh;margin:0;text-align: center;font-size: 27px;color: #4884dc;font-family: 'Eczar', cursive,sans-serif;">坚持学习的人永葆青春</span>
		</div>
	
		<div v-show="false">
			<div class="form" v-show="playtimeShow">
				<input class="input" placeholder="请输入工号" v-model="thisJobNo" type="text">
				<span class="input-border"></span>
			</div>
			<button v-show="playtimeShow" :style="'margin-top:'+ windowWidth*0.16 +'px;'" @click="sumbitJobNo"> let's go<span></span></button>
		</div>
		<p v-show="!playtimeShow" style="text-align:center ; color: #b55d7f;padding: 11px;font-size: 1.27rem;">你在休息的时候，你的对手在超越。</p>
		<p v-show="!playtimeShow" style="text-align:center ; color: #b55d7f;padding: 11px;font-size: 1.27rem;">赶紧开启您2024年富宝学习之旅，期待你下一期学习成就呦！</p>
		<!-- <svg id="wave" style="transform:rotate(0deg); transition: 0.3s; position:absolute; bottom: 0%;" viewBox="110 00 1440 490" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0"><stop stop-color="rgba(250,204,148,1)" offset="0%"></stop><stop stop-color="rgba(254,294,190,0.4)" offset="100%"></stop></linearGradient></defs><path style="transform:translate(0, 0px); opacity:1" fill="url(#sw-gradient-0)" d="M0,49L60,98C120,147,240,245,360,277.7C480,310,600,278,720,228.7C840,180,960,114,1080,147C1200,180,1320,310,1440,375.7C1560,441,1680,441,1800,432.8C1920,425,2040,408,2160,359.3C2280,310,2400,229,2520,212.3C2640,196,2760,245,2880,294C3000,343,3120,392,3240,408.3C3360,425,3480,408,3600,408.3C3720,408,3840,425,3960,392C4080,359,4200,278,4320,253.2C4440,229,4560,261,4680,236.8C4800,212,4920,131,5040,138.8C5160,147,5280,245,5400,302.2C5520,359,5640,376,5760,383.8C5880,392,6000,392,6120,334.8C6240,278,6360,163,6480,98C6600,33,6720,16,6840,81.7C6960,147,7080,294,7200,367.5C7320,441,7440,441,7560,408.3C7680,376,7800,310,7920,294C8040,278,8160,310,8280,334.8C8400,359,8520,376,8580,383.8L8640,392L8640,490L8580,490C8520,490,8400,490,8280,490C8160,490,8040,490,7920,490C7800,490,7680,490,7560,490C7440,490,7320,490,7200,490C7080,490,6960,490,6840,490C6720,490,6600,490,6480,490C6360,490,6240,490,6120,490C6000,490,5880,490,5760,490C5640,490,5520,490,5400,490C5280,490,5160,490,5040,490C4920,490,4800,490,4680,490C4560,490,4440,490,4320,490C4200,490,4080,490,3960,490C3840,490,3720,490,3600,490C3480,490,3360,490,3240,490C3120,490,3000,490,2880,490C2760,490,2640,490,2520,490C2400,490,2280,490,2160,490C2040,490,1920,490,1800,490C1680,490,1560,490,1440,490C1320,490,1200,490,1080,490C960,490,840,490,720,490C600,490,480,490,360,490C240,490,120,490,60,490L0,490Z"></path></svg> -->
    </div>
</template>
  
<script>
import jieliufa from '@/utils/jieliufa'
export default {
	data() {
		return {
			thisJobNo: '',
			buttonShow: true,
			windowWidth: window.innerHeight,
			playtimeShow: true
		}
	},
	methods: {
		sumbit: jieliufa.throttle(function() {
			/*节流：
			*在规定的时间间隔范围内不会重发触发回调，只有大于时间间隔才会触发回调
			*也就是说，把频发触发变成少量触发
			*/
			this.sumbitJobNo()
		},1000),
		sumbitJobNo() {
			if (!this.thisJobNo) {
			this.$message({
				message: "工号不能为空",
				type: "warning",
				center: true
			})
			return
			}
			this.$emit('inputJobNo',this.thisJobNo)
		},
	},
	created() {}
    }
</script>
  
<style scoped>
.body {
    /* background:linear-gradient(-170deg,#ffa6a2 , #fecc97); */
    background:   url("../../assets/logo2.png") right  top  no-repeat,
                  url("../../assets/25February/bg.jpg")  no-repeat;
      background-size: 110px 35px,cover;
    width: 100%;
    height: 100vh;
}
.form {
    --width-of-input: 270px;
    --border-height: 1px;
    --border-before-color: #2672e3;
    /* --border-after-color: linear-gradient(40deg,#fecc94,#fecc94); */
    position: relative;
    width: var(--width-of-input);
    margin: 0 auto;
    top: 87px;
}
.input {
    color: #2672e3;
    font-size: 1.1rem;
    background-color: transparent;
    width: 100%;
    box-sizing: border-box;
    padding-inline: 0.5em;
    padding-block: 0.7em;
    border: none;
    border-bottom: var(--border-height) solid var(--border-before-color);
    font-family: monospace;
}
.input-border {
    position: absolute;
    background: var(--border-after-color);
    width: 0%;
    height: 2px;
    bottom: 0;
    left: 0;
    transition: 0.3s;
}

input:focus {
    outline: none;
}  
  
button {
    width: 7em;
    position: absolute;
    height: 2.5em;
    border: 3px ridge #78a3e4;
    outline: none;
    background-color: transparent;
    color: #2672e3;
    transition: 1s;
    border-radius: 0.3em;
    font-size: 16px;
    font-weight: bold;
    left: 50%;
    transform: translateX(-50%);
    animation: light 3s infinite;
}
  
@keyframes light {
    0%{
      box-shadow: inset 0px 0px 7px #8fb5ee;
    }
    50%{
      /* letter-spacing: 0.25em; */
      box-shadow: inset 0px 0px 47px #80abec;
    }
    100%{
      /* letter-spacing: 0.25em; */
      box-shadow: inset 0px 0px 7px #2672e3;
    }
  }
  
button::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
    transform-origin: center;
}
  
button::before {
    content: "";
    transform-origin: center;
    position: absolute;
    top: 80%;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
} 
</style>